if (typeof navigator.serviceWorker !== 'undefined') {
    navigator.serviceWorker.register('/service-worker.js')
}

// CSRF token
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {
// form-editable
    $(document).on('change', '.form-editable input, .form-editable select, .form-editable textarea', function(){
        let $element = $(this);
        let $parent = $element.parents('.form-editable');
        let name = $element.attr('name');
        const disableLoading = $parent.data('disable-loading') ?? false;

        if(name){
            $.ajax({
                url: $(this).parents('.form-editable').data('save-url'),
                type: 'POST',
                dataType: 'json',
                data: {
                    'name': name,
                    'value': ($(this).is(':checkbox')?($(this).is(":checked")?1:0):$(this).val()),
                    'details': $(this).data('details'),
                    'details2': $(this).data('details2'),
                    'option-details': $(this).find(":selected").data('details'),
                },
                success: function (data) {
                    var responseText = '';
                    $.each(data.response, function( index, value ) {
                        responseText += value+'<br/>';
                    });

                    Swal.fire({
                        icon: 'success',
                        title: responseText,
                        toast: true,
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                    })

                    const redirectUrl = $parent.data('redirect-url');
                    const redirectAfter = parseInt($parent.data('redirect-after')) || 0;

                    if (redirectUrl) {
                        setTimeout(function() {
                            window.location.href = redirectUrl;
                        }, redirectAfter);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var responseJson = jQuery.parseJSON(jqXHR.responseText);
                    var responseText = '';
                    $.each(responseJson.response, function( index, value ) {
                        responseText += value+'<br/>';
                    });
                    Swal.fire({
                        icon: 'error',
                        html: responseText,
                    })
                },
                beforeSend: function () {
                    if (!disableLoading) {
                        $("#loading-indicator").fadeIn('fast');
                    }
                },
                complete: function () {
                    if (!disableLoading) {
                        $("#loading-indicator").fadeOut('fast');
                    }
                }
            });
        }
    });


// Keep tabs open
    function openNestedTabHref(hash){
        var res = hash.split("__");
        var res_length = res.length;
        $.each(res, function (index, element) {
            if(!element.startsWith('#')){
                element = '#'+element;
            }
            $('[role="tab"][data-bs-target="' + element + '"]').tab('show');
            if(index === (res_length - 1)){
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('[data-bs-target="'+element+'"]').offset().top - 10 +'px'
                    }, 'fast');
                }, 500);
            }
        });
        bootstrap.Offcanvas.getInstance($('.offcanvas')).hide();
    }

    $('[data-open-nested-tab-href]').click(function(){
        openNestedTabHref($(this).data('openNestedTabHref'));
    });

    $('[role="tab"]').on('shown.bs.tab', function (e) {
        window.dispatchEvent(new Event('resize'));

        var hash = $(e.target).attr('href');
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }
    });

    setTimeout(()=>{
        var hash = window.location.hash;
        if (hash) {
            // nested tabs
            if(hash.includes('__')){
                openNestedTabHref(hash);
            }
            // single tab
            else{
                $('[role="tab"][data-bs-target="' + hash + '"]').tab('show');
            }
        }
    }, 500);

    // Form-editable
    $(document).on('change', '.form_editable input, .form_editable select, .form_editable textarea', function(){
        let name = $(this).attr('name');
        const disableLoading = $(this).parents('.form_editable').data('disable-loading') ?? false;
        if(name){
            $.ajax({
                url: $(this).parents('.form_editable').data('save-url'),
                type: 'POST',
                dataType: 'json',
                data: {
                    'name': name,
                    'value': ($(this).is(':checkbox')?($(this).is(":checked")?1:0):$(this).val()),
                    'details': $(this).data('details'),
                    'details2': $(this).data('details2'),
                    'option-details': $(this).data('details') || $(this).find(":checked").data('details'),
                },
                success: function (data) {
                    var responseText = '';
                    $.each(data.response, function( index, value ) {
                        responseText += value+'<br/>';
                    });
                    Swal.fire({
                        icon: 'success',
                        title: responseText,
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                    })
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var responseJson = jQuery.parseJSON(jqXHR.responseText);
                    var responseText = '';
                    $.each(responseJson.response, function( index, value ) {
                        responseText += value+'<br/>';
                    });
                    Swal.fire({
                        icon: 'error',
                        html: responseText,
                    })
                },
                beforeSend: function () {
                    if (!disableLoading) {
                        $("#loading-indicator").fadeIn('fast');
                    }
                },
                complete: function () {
                    if (!disableLoading) {
                        $("#loading-indicator").fadeOut('fast');
                    }
                }
            });
        }
    });

    // UE Alert Handler
    if(sessionStorage.getItem('isUeAlertBoxClosed') === 'true'){
        $('#ueAlert').hide();
    }

    $('#ueAlert .btn-close').click(function (){
        sessionStorage.setItem('isUeAlertBoxClosed', 'true')
    });

    // Lightbox Gallery
    new SimpleLightbox('.lightbox', {
        captionSelector: 'self',
        scrollZoomFactor: 0.1,
        uniqueImages: true,
    });
});
